import {combineReducers} from 'redux';
import {getFlag,getLocatState } from './productReducer';


const reducers=combineReducers({
    getFlag:getFlag,
    getLocatState:getLocatState
});

export default reducers; 